import { authedApiFetch } from '../utils/Api';

const inputSignalRuleSubscriptionService = {
	deleteSubscription: async (subscription_id) => {
		const response = await authedApiFetch({
			endpoint: `/input_signal_rule_subscriptions/${subscription_id}`,
			method: 'DELETE',
		});
		return response;
	},

	createSubscription: async (alert_id) => {
		const response = await authedApiFetch({
			endpoint: `/input_signal_rule_subscriptions`,
			method: 'POST',
			payload: { input_signal_rule_id: alert_id },
		});
		return response;
	},
};

export default inputSignalRuleSubscriptionService;
